import rules from "../../utils/rules";
import apiService from "../../api/api.service";
import { mapGetters } from "vuex";
import pageheader from "../pageheader";
import utils from "../../utils/util";
export default {
  name: "change-password",
  components: { pageheader },
  data() {
    return {
      rules: rules,
      valid: true,
      oldPassword: null,
      confirmPassword: null,
      newPassword: null,
      loading: false,
      showOldpass: true,
      showConfirmpass: true,
      showNewpass: true,
      confirmPasswordRules: [
        value => !!value || "Confirm password is required",
        value =>
          value === this.newPassword ||
          "The password confirmation does not match."
      ],
      input: {}
    };
  },
  computed: {
    ...mapGetters(["id", "roles"])
  },
  mounted() {
    this.input = utils.getInputContent("changepassword", this.roles);
  },
  methods: {
    async changePassword() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let payload = {
            oldPassword: this.oldPassword,
            newPassword: this.newPassword
          };
          let response = await apiService.changepassword(payload, this.id);
          if (response) {
            this.loading = false;
            this.$toast.success("Password changed successfully");
            this.reset();
          }
        } catch (error) {
          this.$toast.error("Unable to update the password" + error);
          this.loading = false;
        }
      }
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
